import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { OperatorsListComponent } from './operators-list.component';
import { OperatorsListService} from './operators-list.service';
import { OperatorsService } from '../../../common/operators/operators.service';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { LoadingModule } from '../loading/loading.module';
import { TooltipModule } from '../tooltip/tooltip.module';
import { ScrollingModule } from '@angular/cdk/scrolling';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SvgIconModule,
    TranslateModule,
    LoadingModule,
    MatInputModule,
    TooltipModule,
    ScrollingModule
  ],
  declarations: [
    OperatorsListComponent
  ],
  providers: [
    OperatorsService,
    OperatorsListService
  ],
  exports: [
    OperatorsListComponent
  ]
})

export class OperatorsListModule {}
